export interface Report {
  id: number;
  total_sent: number;
  total_delivered: number;
  total_pending: number;
  total_failed: number;
  total_absent_from_network: number;
  invalid: number;
  total_delivered_to_network: number;
  report_date: string;
  created_at: string;
  updated_at: string;
  sms_class: string;
}

export interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
}

export interface ReportsPagination {
  current_page: number;
  data: Report[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: PaginationLink[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface ReportsResponse {
  data: ReportsPagination;
}

export interface ReportFormData {
  total_sent: string;
  total_delivered: string;
  total_pending: string;
  total_failed: string;
  total_absent_from_network: string;
  invalid: string;
  total_delivered_to_network: string;
  report_date: string;
  sms_class: string;
}

export interface ReportPayload {
  total_sent: number;
  total_delivered: number;
  total_pending: number;
  total_failed: number;
  total_absent_from_network: number;
  invalid: number;
  total_delivered_to_network: number;
  report_date: string;
  sms_class: string;
}

export interface UpdateReportProps {
  report: Report;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

  export const formatNumber = (num: number): string => {
    return new Intl.NumberFormat().format(num);
  };
